import React from 'react';
import { useSelector } from 'react-redux';
import { useFela } from 'react-fela';
import { usePlayer } from '../../../PlayerContext';
import { largeScreen, smallScreen } from '../../../../common/mixins';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

const rules = ({ theme, isMobile }) => ({
  color: 'white',
  cursor: 'pointer',
  display: 'flex',
  marginBottom: '-3px',
  marginRight: theme.margin.xlarge,
  opacity: theme.opacity.enabled,
  height: theme.iconHeight.large,
  transition: theme.transition.default,
  willChange: 'opacity',
  ':hover': {
    opacity: theme.opacity.hovered,
  },
  extend: [
    {
      condition: isMobile,
      style: {
        opacity: theme.opacity.hovered,
      },
    },
    largeScreen({
      height: theme.iconHeight.medium,
      marginRight: theme.margin.large,
    }),
    smallScreen({
      height: theme.iconHeight.small,
      marginRight: theme.margin.medium,
    }),
  ],
});

function AirPlay() {
  const { isAirPlayAvailable } = useSelector(state => state.playback);
  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);
  const { css } = useFela({ isMobile });
  const player = usePlayer();

  if (!isAirPlayAvailable) {
    return null;
  }

  return (
    <div className={css(rules)} onClick={() => player.invokeAirplay()}>
      <svg viewBox="0 0 32 29" width="34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.9984 28.8481C10.4059 28.8481 10.0028 28.5815 9.78916 28.0485C9.57551 27.5155 9.68082 27.0368
            10.1051 26.6126L15.0548 21.6722C15.1962 21.5295 15.3455 21.4269 15.5027 21.3643C15.6599 21.3018 15.8259
            21.2705 16.0005 21.2705C16.1752 21.2705 16.3394 21.3018 16.4931 21.3643C16.6468 21.4269 16.7943 21.5295
            16.9357 21.6722L21.8855 26.6126C22.3097 27.0368 22.415 27.5155 22.2014 28.0485C21.9877 28.5815 21.5846
            28.8481 20.9921 28.8481H10.9984ZM2.68428 25.6961C1.94609 25.6961 1.31417 25.4333 0.788499 24.9076C0.262833
            24.3819 0 23.75 0 23.0118V2.69373C0 1.95297 0.262833 1.31883 0.788499 0.791297C1.31417 0.263765 1.94609 0
            2.68428 0H29.3063C30.047 0 30.6812 0.263765 31.2087 0.791297C31.7362 1.31883 32 1.95297 32 2.69373V23.0118C32
            23.75 31.7362 24.3819 31.2087 24.9076C30.6812 25.4333 30.047 25.6961 29.3063 25.6961H23.2867C22.9078 25.6961
            22.5894 25.5665 22.3315 25.3072C22.0736 25.0479 21.9446 24.7279 21.9446 24.3471C21.9446 23.9662 22.0736 23.6485
            22.3315 23.3938C22.5894 23.1392 22.9078 23.0118 23.2867 23.0118H29.3063V2.69373H2.68428V23.0118H8.70383C9.08269
            23.0118 9.40109 23.1415 9.65903 23.4007C9.91699 23.66 10.046 23.9801 10.046 24.3609C10.046 24.7417 9.91699
            25.0594 9.65903 25.3141C9.40109 25.5688 9.08269 25.6961 8.70383 25.6961H2.68428Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

export default React.memo(AirPlay);
